<template>
	<a-tooltip
		v-if="show"
		placement="top"
	>
		<template slot="title">
			<span v-if="enabled">💬 Chat activado</span>
			<span v-else>🙊 Chat desactivado</span>
		</template>

		<a-switch
			v-model="enabled"
			checked-children="💬"
			un-checked-children="💬"
			default-checked
			class="mx-2"
		/>
	</a-tooltip>
</template>

<script>
export default {
	name: 'Chat',
	props: {
		show: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			chatLoaded: false
		};
	},
	computed: {
		connected() {
			if (this.$gestios !== undefined) return this.$gestios.connected;
			return false;
		},
		enabled: {
			get() {
				return this.$settings.isChatEnabled;
			},
			set(val) {
				this.$store.commit('CHANGE_SETTING', { setting: 'isChatEnabled', value: val });
			}

		}
	},
	watch: {
		connected() {
			if (this.chatLoaded) this.identify();
		},
		enabled(val) {
			if (!val && window.fcWidget) { window.fcWidget.destroy(); }
			if (val) this.load();
		}
	},
	created() {
		if (this.$settings.isChatEnabled) this.load();
	},
	methods: {
		load() {
			this.$loadScript('https://wchat.freshchat.com/js/widget.js').then(() => {
				if (window.fcWidget) {
					this.chatLoaded = true;

					window.fcWidget.init({
						token: '5f5d2126-28d6-4d27-afea-62b5d8e37ffb',
						host: 'https://wchat.freshchat.com',
						open: true,
						locale: 'es'
					});

					this.identify();
				}
			});
		},
		identify() {
			if (this.connected) {
				window.fcWidget.setExternalId(`${this.$gestios.profile.Nick}#${this.$gestios.project.name}`);
				window.fcWidget.user.setFirstName(this.$gestios.profile.Name);
				window.fcWidget.user.setEmail(this.$gestios.profile.Email);
				window.fcWidget.user.setProperties({
					phone: this.$gestios.profile.Phone,
					nick: this.$gestios.profile.Nick
				});
			}

			window.fcWidget.user.setProperties({
				project: this.$gestios.project.name
			});
		}
	}
};
</script>
